import React from 'react';
import SolutionSealCompleteWrapper from 'components/SolutionSealCompleteWrapper';

export default function SolutionSealCompleteContainer() {
  return (
    <SolutionSealCompleteWrapper />
  )
}
